<template>
  <q-dialog
    v-model="shown"
  >
    <q-card style="min-width: 300px;">
      <q-form
        ref="formRef"
      >
        <q-card-section>
          <div class="row justify-between">
            <div class="text-h5">
              Tip Adjustment
            </div>
            <q-btn
              flat
              round
              dense
              icon="close"
              @click="close"
            />
          </div>
        </q-card-section>

        <q-card-section>
          <q-inner-loading :showing="performingAction" />
          <div class="row q-mb-sm">
            <div class="text-h6 q-mr-sm" />
            <q-icon
              size="md"
              name="engineering"
            />
          </div>
          <div class="row justify-around">
            <q-select
              v-model="selectedPaymentId"
              label="Payment to Adjust"
              class="full-width"
              :options="paymentConnectorPaymentsOptions"
              :rules="[val => !!val && val !== null || $t('form.errors.required')]"
              emit-value
              map-options
            />
          </div>
          <div class="row q-mt-md">
            <q-input
              v-model.number="tipAmount"
              :rules="[val => val !== null && val >= 0]"
              label="Tip Amount"
              type="number"
              class="full-width"
              :prefix="currentCircuit.localeCurrencySymbol"
            />
          </div>
        </q-card-section>

        <q-card-actions>
          <q-btn
            class="full-width"
            color="dark"
            :label="`Update Tip Amount (${currentCircuit.localeCurrencySymbol}${tipAmount})`"
            icon="account_balance"
            :disable="performingAction"
            @click="updateTipAmount"
          />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import Order from 'src/models/order/Order'
import FormValidationMixin from 'src/modules/admin/mixins/FormValidationMixin'

export default {
  name: 'TipAdjustDialog',
  mixins: [FormValidationMixin],
  props: {
    order: {
      type: Order,
      required: true
    }
  },
  data () {
    return {
      shown: false,
      performingAction: false,
      selectedPaymentId: null,
      tipAmount: 0
    }
  },
  context: ['currentRegisterClient'],
  configuration: ['currentCircuit'],
  computed: {
    paymentConnectorName () {
      return this.currentRegisterClient?.registerStation?.paymentConnectorName
    },
    paymentConnectorPayments () {
      return _.filter(this.order.payments.data, { state: 'completed', subtype: this.paymentConnectorName })
    },
    paymentConnectorPaymentsOptions () {
      return _.map(this.paymentConnectorPayments, payment => {
        return {
          label: payment.details,
          value: payment.id
        }
      })
    }
  },
  methods: {
    close () {
      this.shown = false
    },
    show () {
      this.shown = true
    },
    updateTipAmount () {
      this.validateForm(async () => {
        await this.performAction('tip_adjust', {
          payment_id: this.selectedPaymentId,
          amount_cents: Math.round(this.tipAmount * 100)
        })
      })
    },
    async performAction (name, options = {}) {
      this.performingAction = true

      try {
        await this.$paymentConnectorHandler.performMaintenanceAction(this.currentRegisterClient, name, options)
        this.close()
      } catch (exception) {
        this.$q.notify({
          message: 'Failed to perform action: ' + exception.message,
          color: 'negative',
          position: 'top'
        })
      }

      this.performingAction = false
    }
  }
}

</script>
